/**
 * Feature Flags
 * 
 * Centralized feature toggles for the Turn Platform.
 * Toggle features on/off without removing code.
 * 
 * To re-enable a feature, set it to true.
 */

export const FEATURES = Object.freeze({
  /** 
   * Turn Art illustration generation via Gemini.
   * When false: generation is not triggered, Turn Art tab is hidden,
   * but all code paths remain intact for re-enablement.
   */
  TURN_ART_GENERATION: false,
} as const);
